import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { ITheme } from '@nibtravel/shared/ui/theme';
import { AppConfigState } from '@nibtravel/shared/util/app-config';

@Component({
  selector: 'tvl-qqc',
  template: `
    <nibtravel-qqc
      [isStandalone]="true"
      [theme]="themeConfig"
      loader="preloader"
      #themeLoader="theme"
    ></nibtravel-qqc>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  themeConfig!: ITheme;

  constructor(private store: Store) {}

  ngOnInit() {
    this.themeConfig = this.store.selectSnapshot(AppConfigState.getThemeConfig);
    this.themeConfig.isStandalone = true;
  }
}
